import { FC } from 'react';

import { Button, Input } from '@/components/ui';
import { ListChoices } from './ListChoices';
import { useListSelection } from './useListSelection';
import type { ListGroupCondition } from '@/features/list-groups/list-groups.types';

interface Props {
  countryKey: string;
  initial?: { listIds: number[] };
  onApply: (condition: ListGroupCondition) => void;
}

export const ListsConditionEditor: FC<Props> = ({ countryKey, initial, onApply }) => {
  const state = useListSelection(countryKey, initial?.listIds);
  const { query, setQuery, selected, clear } = state;

  return (
    <div className="flex w-80 max-w-[85vw] flex-col gap-2 p-3">
      <label className="flex flex-col gap-1 text-xs text-muted-foreground">
        Search lists by name or ID
        <Input
          autoFocus
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          className="h-9 rounded-md border border-input bg-background px-2 text-sm text-foreground"
        />
      </label>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{selected.length} selected</span>
        <button type="button" onClick={clear} disabled={!selected.length}>Clear selection</button>
      </div>
      <ListChoices state={state} />
      <Button size="sm" disabled={!selected.length} onClick={() => onApply({ type: 'lists', listIds: selected })}>
        Apply selection
      </Button>
    </div>
  );
};
